import React, { ReactNode, RefObject } from "react";
import { Popup, Button } from "semantic-ui-react";

interface IToolTip {
  children: ReactNode;
  containerRef?: RefObject<HTMLDialogElement>; // this is required for the tooltip to show if it's is being rendered outside of document.body (e.g. <dialog> modal)
}

export const Tooltip = ({ children, containerRef }: IToolTip) => {
  return (
    <div className='tw-ml-1 tw-inline-block'>
      <Popup
        hoverable
        size='small'
        inverted
        mountNode={containerRef?.current || undefined}
        trigger={
          <div>
            <Button
              aria-labelledby='moreInfoLabelTooltip'
              icon='question circle outline'
              className='tw-border-none tw-bg-transparent tw-p-1 hover:tw-bg-[#cacbcd]'
              type='button'
              aria-describedby='tooltipPopupContent'
            />
            <span id='moreInfoLabelTooltip' aria-hidden='true' className='sr-only'>
              More info
            </span>
          </div>
        }
        on={["hover", "click"]}
        closeOnTriggerBlur
        closeOnTriggerClick={false}
      >
        <Popup.Content id='tooltipPopupContent' aria-live='polite'>
          {children}
        </Popup.Content>
      </Popup>
    </div>
  );
};

export default Tooltip;
